import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
import { withRouter } from "found";

// web-app-nav imports
import { IContainer, IProps, IState } from "./WebAppNav.d";
import { webAppNavFragments } from "./WebAppNav.gql";
import { styles } from "./WebAppNav.styles";

// components
import { LogoHorizontal } from "@components/logo";
import { WebAppNavAvatarMenu } from "./web-app-nav-avatar-menu";

// state
import { IReduxState } from "@reducers/root.reducer";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";
import { toggleExpanded } from "@actions/settings.actions";

// util
import { colors } from "@clockwise/web-commons/src/styles/color.styles";
import { track, TrackingEvents } from "@util/analytics.util";

// constants
import { paths } from "@constants/site.constant";

// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import { IconButton, Tooltip } from "@material-ui/core";
import { Menu } from "@material-ui/icons";

///////////////
// Component //
///////////////

class WebAppNavCmpt extends React.Component<IProps, IState> {
  static defaultProps = {
    hideBetaLogo: false,
    hideAdvancedMenu: false,
    hideLogo: false,
  };

  constructor(props: IProps) {
    super(props);

    this.state = {};
  }

  private onClickLogo = () => {
    track(TrackingEvents.APP_NAV.LOGO);
    this.props.router.push(paths.webApp);
  };

  ///////////////
  // Rendering //
  ///////////////

  public render() {
    return (
      <div className={this.props.classes.container}>
        <div className={this.props.classes.absoluteContainer}>
          <div className={this.props.classes.gradientBar} />
          <div className={this.props.classes.rowFlexedContainer}>
            {this.props.onClickMenu ? (
              <Tooltip title="Menu">
                <IconButton style={{ marginRight: 12 }} onClick={this.props.onClickMenu}>
                  <Menu />
                </IconButton>
              </Tooltip>
            ) : null}
            {!this.props.hideLogo ? (
              <div className={this.props.classes.logoContainer} onClick={this.onClickLogo}>
                <LogoHorizontal fill={colors.blueDusk.darker} style={styles.logo} />
              </div>
            ) : null}
            <div>{this.props.children}</div>
            {!this.props.hideMenu ? (
              <div className={this.props.classes.logout}>
                <WebAppNavAvatarMenu
                  viewer={this.props.viewer}
                  hideAdvancedMenu={this.props.hideAdvancedMenu}
                  router={this.props.router}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////

const WebAppNavStyled = withStyles(styles)(WebAppNavCmpt);

////////////
// Router //
////////////

const WebAppNavWithRouter = withRouter(WebAppNavStyled);

///////////
// Redux //
///////////

function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    fastCrawlFinished: state.onboarding.fastCrawlFinished,
  };
}

const WebAppNavRedux = connect(mapStateToProps, {
  setSettingsDialogOpen,
  toggleExpanded,
})(WebAppNavWithRouter);

///////////
// Relay //
///////////

export const WebAppNav = createFragmentContainer<IContainer>(WebAppNavRedux, webAppNavFragments);
